import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PostingsApi from '../../../API/shipment/postings-api';
import { addShipmentPostings } from '../../../actions/postings';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, Input, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader, TablePagination } from '../../../components/Basic/Table';
import { Text } from '../../../components/Basic/WrapsStyle';
import { MAP_SKLAD_RUS, TYPE_BUTTONS, WAREHOUSES } from '../../../constans';
import PostingLine from './PostingLine';
import styles from './styles.module.scss';

const SHOPS = {
  Ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  Yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  Wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  Sber: ['Все', 'megamarket1', 'megamarket1'],
};

export const MARKETS_LIST = ['Не выбрана', 'Ozon', 'Wb', 'Yandex', 'Megamarket', 'Avito'];;

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '120px', // 6
  '220px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '220px', // 11
  '80px', // 12
];

const STATUSES = ['Не выбран', 'Нет в наличии', 'Резерв', 'Частичный резерв', 'Излишки', 'Не хватает'];
const STATUSES_ORDERS_WB = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Прибыл на ПВЗ',
  'Продано',
  'Отменено',
  'Отменено клиентом',
  'Обнаружен брак',
];
const STATUSES_ORDERS_OZON = [
  'Не выбран',
  'Ожидает отгрузки',
  'Доставляется',
  'Продано',
  'Не принят на CЦ',
  'Арбитраж',
  'Отменено',
];

const SKLAD_LIST = ['Не выбран', ...WAREHOUSES];

const DISCREPANCIES = ['Не выбран', 'Брак', 'Пересорт', 'Недостача', 'Нет'];
const STATUSES_ORDERS_YANDEX = ['Не выбран'];

const STATUSES_ORDERS = {
  Ozon: STATUSES_ORDERS_OZON,
  Yandex: STATUSES_ORDERS_YANDEX,
  Wb: STATUSES_ORDERS_WB,
};

const FILTER = {
  0: 'variance',
  1: 'variance_approved',
  2: 'variance_not_approved',
  3: 'variance_revoked',
  4: 'variance_posting_shipped',
  5: 'variance_confirmed',
  6: 'variance_not_confirmed',

};

const CalcMonthAgo = () => {
  const start = new Date();
  start.setTime(start.getTime() - 30 * 24 * 3600000);

  return start;
};

const CalcFeatureTwoDay = () => {
  const start = new Date();
  start.setTime(start.getTime() + 2 * 24 * 3600000);
  return start;
};

function DiscrepanciesPostingsPage() {
  const user = useSelector((store) => store.user);
  const [checkAll, setCheckAll] = useState(false);
  const [pdfFilePath, setPdfFilePath] = useState('');
  const [sklad, setSklad] = useState(SKLAD_LIST[0]);

  const [shipmentMode, changeShipmentMode] = useState(true);

  const [market, setMarket] = useState(MARKETS_LIST[0]);
  const [postingsPrint, setPostingsPrint] = useState({});

  const [period, setPeriod] = useState({ start: CalcMonthAgo(), end: CalcFeatureTwoDay() });

  const useFocus = () => {
    const htmlElRef = useRef(null);
    const setFocus = () => {
      htmlElRef.current && htmlElRef.current.focus();
      htmlElRef.current && htmlElRef.current.select();
    };

    return [htmlElRef, setFocus];
  };

  const [inputRef, setInputFocus] = useFocus();

  const [count, setCount] = useState([]);
  const [page, setPage] = useState(1);

  const [show, setShow] = useState(20);
  const [search, setSearch] = useState('');

  const [countStock, setCountStock] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ providerId: '' });
  const allProviders = useSelector((store) => store.providers);
  const [providers, setProviders] = useState([]);
  const [varianceReturn, setVarianceReturn] = useState('Не выбран');

  const [status, changeStatus] = useState(STATUSES[0]);
  const [discrepancies, changeOrderDiscrepancies] = useState('Не выбран');
  const [shop, setShop] = useState('Все');

  const { ids, byIds, map } = useSelector((store) => store.postings);
  const dispatch = useDispatch();

  const onChangePage = (v) => {
    setPage(v);
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const params = useMemo(() => {
    return {
      limit: parseInt(show),
      page,
      search: search.trim(),
      providerId: provider.id,
      tab: FILTER[tab],
      shop: shop === 'Все' ? undefined : shop.toLowerCase(),
      market: market === 'Не выбрана' ? undefined : market.toLowerCase(),
      skladName: sklad === 'Все' ? undefined : MAP_SKLAD_RUS[sklad],
      period: {
        startDate: period.start,
        endDate: period.end,
      },
      sortType: 'variance',
      filters: {
        varianceReturn: varianceReturn === 'Не выбран' ? undefined : varianceReturn,
        // orderStatus: orderStatus === 'Не выбран' ? undefined : orderStatus,
        productsStatus: status === 'Не выбран' ? undefined : status,
        productDiffStatus: discrepancies === 'Не выбран' ? undefined : discrepancies,
      },
    };
  }, [tab, show, search, provider.id, market, shop, status, period, discrepancies, sklad, varianceReturn]);

  const loadData = () => {
    PostingsApi.getDiscrepanciesPostings({ data: params })
      .then((res) => {
        const { postings, all_count = {}, count, cardsMap = {} } = res;

        const { variance, variance_revoked, variance_confirmed, variance_not_confirmed, variance_posting_shipped, variance_approved, variance_not_approved } = all_count;
        setCount(count);
        setCountStock([variance, variance_approved, variance_not_approved, variance_revoked, variance_posting_shipped, variance_confirmed, variance_not_confirmed,]);
        const ids = postings.map((item) => item.posting_number);
        postings.forEach((item) => (byIds[item.posting_number] = item));

        dispatch(addShipmentPostings({ byIds, ids, map: cardsMap }));
      })
      .catch();
  };

  useEffect(() => {
    loadData();
  }, [params]);

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  useEffect(() => {
    setShop('Все');
  }, [market]);

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === 'user';

  return (
    <Content>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={['Все расхождения', 'Согласовано', 'Не согласовано', 'Вычерки', 'Товар отгружен', 'Оформлены', 'Не оформлены',]}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />
        </Row>
        <Input
          value={search}
          ref={inputRef}
          onBlur={(v) => setSearch(v)}
          onClickEnter={(v) => setSearch(v)}
          label="Поиск"
        />
        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

        <Row spaceBetween={true}>
          <Row style={{ height: '40px', alignItems: 'flex-end' }}>
            <Select
              label="Показать на странице"
              select={show}
              list={['20', '50', '100', '150', '200', '500', '1000']}
              onSelect={(v) => setShow(v)}
              width="150px"
              style={{ marginRight: '15px' }}
            />
            <Select
              list={MARKETS_LIST}
              select={MARKETS_LIST[0]}
              label="Площадка"
              onSelect={(v) => setMarket(v)}
              width={'150px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              list={SHOPS[market] || []}
              select={(SHOPS[market] || [])[0]}
              disabled={market === MARKETS_LIST[0]}
              label="Магазин"
              onSelect={(v) => setShop(v)}
              width={'150px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Поставщик"
              select={provider}
              valueFn={(p) => p.name}
              list={providers}
              width="200px"
              onSelect={(v) => changeProvider(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Статус товара"
              select={status}
              list={STATUSES}
              width="200px"
              onSelect={(v) => changeStatus(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Расхождение"
              select={discrepancies}
              list={DISCREPANCIES}
              width="200px"
              onSelect={(v) => changeOrderDiscrepancies(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              list={SKLAD_LIST}
              select={sklad}
              label="Склад отгрузки"
              onSelect={(v) => setSklad(v)}
              width={'200px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              list={[
                'Не выбран',
                'Да',
                'Нет',
                'Не определено',
              ]}
              select={varianceReturn}
              label="Будет возврат"
              onSelect={(v) => setVarianceReturn(v)}
              width={'150px'}
              style={{ marginRight: '15px' }}
            />
            <Button
              type={TYPE_BUTTONS.WHITE}
              onClick={() =>
                PostingsApi.excelDiscrepancies({
                  data: {
                    ...params,
                    limit: undefined,
                    page: undefined,
                    sortType: undefined,
                  }
                })
              }
              style={{ marginLeft: '10px' }}
            >
              Скачать расхождения
            </Button>
          </Row>

          <Row>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Начало периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.start}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, start: new Date(v) })}
                />
              </Row>
            </Column>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Конец периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.end}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, end: new Date(v) })}
                />
              </Row>
            </Column>
          </Row>
        </Row>
      </WhiteBlock>

      <Table styles={styles.table}>
        <TableHeader whiteHeader>
          <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[12]} centerText>
            Дата отгрузки
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[1]}>Позиции в заказе</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Статус товара
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
            Расхождениe при отгрузке
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Комментарий
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Номер УПД
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[11]} centerText={true}>
            Статус оформления расхождения
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[0]} centerText={true}>
            Будет возврат
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Артикул поставщика
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Поставщик
          </HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[4]} centerText={true}>
            Статус заказа
          </HeaderTitle>
        </TableHeader>
        {ids.map((order) => {
          return (
            <PostingLine
              isAdmin={isAdmin}
              order={byIds[order]}
              map={map}
              key={byIds[order].posting_number}
              setInputFocus={setInputFocus}
              postingsPrint={postingsPrint}
            />
          );
        })}
      </Table>
      <TablePagination num={Math.ceil(count / show) || 1} show={page} onChange={onChangePage} />
    </Content>
  );
}

export default DiscrepanciesPostingsPage;
